/*
Documentation

this file creates the admin call center view

*/

import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Container, Row, Col } from "reactstrap";

import keys from 'keys';
import * as _ from 'underscore';

import AssignedAppointments from './AssignedAppointments';
import OverdueTasks from './OverdueTasks';
import OverdueTasksToday from './OverdueTasksToday';
import StaffOnline from './StaffOnline';
import UnreadTexts from './UnreadTexts';
import Voicemail from './Voicemail';
// import OpenDocuments from './OpenDocuments';
// import UnreadEmails from './UnreadEmails';
import OnHold from './OnHold';
import OnCall from './OnCall';
import OffCall from './OffCall';
import CallQueue from './CallQueue';

import A from 'components/markup/links/A';

import { setUsers } from 'store/functions/users/users'
class CallCenterAdmin extends React.Component {
    

    constructor(props) {
        super(props);
        this.state = {
            onCallUsers: null,
            offCallUsers: null,
        }

        // not used but may implement soon to prevent re-rendering
       this.sortUsersThrottled = _.throttle(this.sortUsers, 5000)
    }

    interval = null;
    willUpdateUsers = false

    sortUsers = (props) => {

        let users = [...props.users]
        let onCallUsers = []
        let offCallUsers = []

        users.forEach(u => {

            if( u.call_status !== 'on call') {
                offCallUsers.push(u)
            } else {
                onCallUsers.push(u)
            }

        })

        offCallUsers.sort((a, b) => a.status === 'online' ? -1 : 1)

        this.setState({onCallUsers, offCallUsers});

    }

    componentWillUnmount = () => {
        if(this.interval) clearInterval(this.interval)
    }

    componentWillReceiveProps = (nextProps) => this.sortUsers(nextProps)
    componentDidMount = () => {
        this.sortUsers(this.props)

        this.interval = setInterval(setUsers, 1000)
    }

    render() {

        const { onCallUsers, offCallUsers } = this.state
        const { company, hideHeader } = this.props

        return (
            <>

            <Helmet>
                <title>{`Call Center Admin`}</title>
                <meta name="description" content="Call Center Admin" />
            </Helmet>

            <Container fluid>

                {hideHeader !== true ? (
                    <DashHeaderOpen
                        icon="fas fa-home"
                        icon_link="/dashboard"
                        title={<span>Call Center</span>}
                        breadcrumb_1="Call Center"
                        breadcrumb_2="Admin"
                        actionComponent={(
                            <A  to={`${keys.APP_URL}/dashboard/call_center`} className="btn btn-success">Call Center</A>
                        )}
                    />
                ) : null}
               

                {company.call_routing === 'queue' ? <div className="alert alert-danger">All calls are currently being routed to on hold calls or call backs that have been requested</div> : null}

                 <Row>

                    <Col lg={7} xl={8}>
                        <AssignedAppointments company={company} />
                    </Col>

                    <Col lg={5} xl={4}>

                        <StaffOnline />

                        <Row>
                            <Col md={6}><OverdueTasks       /></Col>
                            <Col md={6}><OverdueTasksToday  /></Col>
                       
                            <Col md={6}><UnreadTexts        /></Col>
                            {/* <Col md={6}><UnreadEmails       /></Col> */}
                     
                            <Col md={6}><Voicemail          /></Col>
                            {/* <Col md={6}><OpenDocuments      /></Col> */}
                        </Row>

                    </Col>

                </Row>


                <Row>

                    <Col lg={5} xl={4}>
                        <OnCall onCallUsers={onCallUsers}/>
                        <OffCall offCallUsers={offCallUsers}/>
                    </Col>

                    <Col lg={7} xl={8}>
                        <OnHold />
                        <CallQueue company={company} />
                    </Col>

                </Row>

            </Container>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        company   : state.companies.company,
        users     : state.users.users,
    };
};

export default connect(mapStateToProps, '')(CallCenterAdmin);

